export function getAllLocalStorage() {
	return Object.entries(localStorage).reduce(
		(agg, [key, value]) => ({
			...agg,
			[key]: value
		}),
		{}
	);
}
